<template>
    <div class="flex flex-col">
        <label class="mb-1 mr-auto md:text-lg text-gray-800" v-if="label">{{ label }} :</label>

        <div class="flex">
            <div class="select w-full">
                <select class="flex bg-white appearance-none focus:shadow-outline w-full" v-model="day" :class="{ 'errors' : hasErrors }">
                    <option :value="null">Jour</option>
                    <option v-for="n in number_of_days" :key="n" :value="n">{{ n.toString().padStart(2, 0) }}</option>
                </select>
            </div>

            <div class="select w-full mx-4" >
                <select class="flex bg-white appearance-none focus:shadow-outline w-full" v-model="month" :class="{ 'errors' : hasErrors }">
                    <option :value="null">Mois</option>
                    <option v-for="n in 12" :key="n" :value="n">{{ n.toString().padStart(2, 0) }}</option>
                </select>
            </div>

            <div class="select w-full">
                <select class="flex bg-white appearance-none focus:shadow-outline w-full" v-model="year" :class="{ 'errors' : hasErrors }">
                    <option :value="null">Année</option>
                    <option v-for="n in 150" :key="n" :value="max_year - n">{{ max_year - n }}</option>
                </select>
            </div>

            <input type="hidden" :value="date" :name="name" v-if="name" />
        </div>

        <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold" style="color: rgb(248, 64, 54);" v-if="hasErrors">
            <span class="block" v-for="(error, index) in errors" :key="index">{{ error }}</span>
        </span>
    </div>
</template>

<script>
export default {
    props: {value: {}, name: {}, errors: {}, label: {}, currentDay: { default: false }},
    data: function () {
        return {
            day: this.currentDay ? (new Date).getDate() : null,
            month: this.currentDay ? (new Date).getMonth() + 1 : null,
            year: this.currentDay ? (new Date).getFullYear() : null,
            max_year: (new Date).getFullYear() + 1
        };
    },
    mounted: function () {
        if(this.value && this.value.length == 10) {
            let date = this.value.split('-');

            this.year = parseInt(date[0]);
            this.month = parseInt(date[1]);
            this.day = parseInt(date[2]);
        }
    },
    computed: {
        number_of_days: function () {
            if(this.month == 2) {
                return this.year % 4 == 0 ? 29 : 28;
            }

            return this.month % 2 == 0 ? 31 : 30;
        },
        date: function () {
            if(this.day == null || this.month == null || this.year == null)
                return null
                
            let day = this.day.toString().padStart(2, '0');
            let month = this.month.toString().padStart(2, '0');

            return this.year + '-' + month + '-' + day;
        },
        hasErrors: function () {
            return this.errors.length > 0;
        }
    },
    watch: {
        date: function () {
            this.$emit('input', this.date);
        }
    }
}
</script>
